/* eslint-disable */
import PropTypes from 'prop-types';
import ServicesContextPropTypes from '../../Contexts/Services/Services.props';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const OrderDetailsPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The current order
   */
  currentOrder: PropTypes.any,

  /**
   * The order id
   */
  orderId: PropTypes.string,

  /**
   * The selected order loading flag
   */
  selectedOrderLoading: PropTypes.bool,

  /**
   * The services to be used by the given entry
   */
  services: ServicesContextPropTypes.services.isRequired,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,
};

export default OrderDetailsPropTypes;
